import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  UserGroupMembersRequest,
  UserGroupRecord,
} from "../UserGroupRecord";

import * as UseUserGroups from "./useUserGroups";

interface RemoveUserGroupMembersArgs {
  userGroupId: string;
  request: UserGroupMembersRequest;
}

export function useRemoveUserGroupMembers() {
  const { userGroupService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<UserGroupRecord, Error, RemoveUserGroupMembersArgs>({
    mutationFn: ({ userGroupId, request }) =>
      userGroupService.removeMembers(userGroupId, request),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseUserGroups.getQueryKey(),
      });
    },
  });
}
